<template>
	<div class="secondpage">
		<div class="title_top">
			<el-row :gutter="20">
				<el-col :span="16" :offset="4">
					<div class="secondpage_con">
						<h2>客户案例</h2>
						<p>项目展示以获得相关授权为前提</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 内容 -->
		<el-row class="content">
			<el-col :span="16" :offset="4">
				<el-row>
					<el-col :xs="24" :sm="6" v-for="(cardboxlist, index) in content" :key="index">
						<div class="box_cont">
							<el-card shadow="hover">
								<img :src="'../../static/' + cardboxlist.imgsrc" alt="" width="60%">
								<h3>{{cardboxlist.title}}</h3>
								<p>{{cardboxlist.content}}</p>
							</el-card>
						</div>
					</el-col>
					<el-col :span="24" v-if="content.length === 0">
						<p class="empty_tip">本站暂未展示客户案例。</p>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				workTask: [],
				content: []
			};
		},
		created() {
			this.workTask = this.$route.query.id
			console.log(this.workTask)
		}

	}
</script>

<style scoped>
	.title_top {
		width: 100%;
		overflow: hidden;
		margin: 0;
		color: #FFFFFF;
		background: url(../assets/1587_jgzynhtp.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.secondpage_con {
		margin: 150px auto;
	}

	.content {
		margin: 50px auto;
	}

	.content h2,
	.content h3,
	.content p {
		color: #000000;
	}

	.content p {
		font-size: 14px;
		color: #475669;
	}

	.box_cont {
		padding: 10px;
		margin: 10px;

	}

	.empty_tip {
		text-align: center;
		color: #909399;
		padding: 60px 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/customercase.vue